import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CheckmarkSquareStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M12 22.25C7.32 22.25 4.97 22.25 3.36 20.64C1.75 19.03 1.75 16.68 1.75 12C1.75 7.32 1.75 4.97 3.36 3.36C4.97 1.75 7.32 1.75 12 1.75C16.68 1.75 19.03 1.75 20.64 3.36C22.25 4.97 22.25 7.32 22.25 12C22.25 16.68 22.25 19.03 20.64 20.64C19.03 22.25 16.68 22.25 12 22.25ZM12 3.25C7.73 3.25 5.59 3.25 4.42 4.42C3.25 5.59 3.25 7.73 3.25 12C3.25 16.27 3.25 18.41 4.42 19.58C5.59 20.75 7.73 20.75 12 20.75C16.27 20.75 18.41 20.75 19.58 19.58C20.75 18.41 20.75 16.27 20.75 12C20.75 7.73 20.75 5.59 19.58 4.42C18.41 3.25 16.27 3.25 12 3.25Z"
				fill="currentColor"
			/>
			<path
				d="M10.5 15.75C10.3 15.75 10.11 15.67 9.97 15.53L7.47 13.03C7.18 12.74 7.18 12.26 7.47 11.97C7.76 11.68 8.24 11.68 8.53 11.97L10.48 13.92L15.45 8.5C15.73 8.2 16.2 8.17 16.51 8.45C16.82 8.73 16.84 9.2 16.56 9.51L11.06 15.51C10.92 15.66 10.73 15.75 10.52 15.75H10.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CheckmarkSquareStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CheckmarkSquareStrokeIcon;
